import { typography } from 'assets/styles'
import styled from 'styled-components'

export const EquipmentNotice = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 16px;
`

export const EquipmentNoticeText = styled.p`
    ${typography.Copy14}
    margin: 0;
    color: ${(props) => props.theme.colors.monochrome.jetlineBlack};
`

export const UnitRow = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
        'label .'
        'field remove';
    column-gap: 5px;
    margin-bottom: 16px;
`

export const UnitLabel = styled.label`
    ${typography.Copy14}
    grid-area: label;
    margin-bottom: 4px;
    color: ${(props) => props.theme.colors.monochrome.ravenSub};
`

export const UnitField = styled.div`
    grid-area: field;
`

export const RemoveUnitButton = styled.div`
    grid-area: remove;

    button {
        width: 60px;
        min-width: 60px;
        height: 60px;
        padding: 0;
    }
`

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    button {
        padding: 5px 10px;
    }
`

export const SubtotalBand = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 54px;
    padding: 0 12px;
    margin-bottom: 16px;
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.monochrome.moonGrey};
`

export const SubtotalLabel = styled.span`
    ${typography.Copy14}
    font-weight: 700;
    color: ${(props) => props.theme.colors.monochrome.ravenSub};
`

export const SubtotalAmount = styled.span`
    ${typography.Heading24Bold}
    color: ${(props) => props.theme.colors.monochrome.ravenSub};
`
